import { createLogger, type ILogger } from "@/infrastructure/services/logger";

interface UseLogger {
  logger: ILogger;
}
interface UseLoggerProps {
  componentName: string;
}

export const useLogger = ({ componentName }: UseLoggerProps): UseLogger => {
  return {
    logger: createLogger(componentName),
  };
};

export default useLogger;
